import { render, staticRenderFns } from "./Active-messages.vue?vue&type=template&id=bed6b50e&scoped=true&"
import script from "./Active-messages.vue?vue&type=script&lang=js&"
export * from "./Active-messages.vue?vue&type=script&lang=js&"
import style0 from "./Active-messages.vue?vue&type=style&index=0&id=bed6b50e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed6b50e",
  null
  
)

export default component.exports